"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _i18n = require("../../../../../Framework/i18n");
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ImageLibraryFilter = _interopRequireDefault(require("../ImageLibraryFilter"));
var _ImageLibraryThumbnail = _interopRequireDefault(require("../ImageLibraryThumbnail"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    root: {
      borderTop: '7px solid ' + theme.palette.primary.main
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
      cursor: 'pointer'
    },
    title: {
      fontWeight: 'bold'
    },
    actionsRoot: {
      padding: theme.spacing(2)
    },
    applyButton: _defineProperty({
      fontSize: 15,
      minWidth: 140,
      height: 40,
      '&:disabled': {
        backgroundColor: '#DDDDDD',
        '& span': {
          color: '#C4C4C4'
        }
      }
    }, theme.breakpoints.down('xs'), {
      height: 56
    })
  };
};
var AddImagePanel = /*#__PURE__*/function (_React$Component) {
  _inherits(AddImagePanel, _React$Component);
  var _super = _createSuper(AddImagePanel);
  function AddImagePanel() {
    var _this;
    _classCallCheck(this, AddImagePanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedImage: {}
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectImage", function (selectedImage) {
      _this.setState({
        selectedImage: selectedImage
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectGalleryImage", function () {
      var selectedImage = _this.state.selectedImage;
      var _this$props = _this.props,
        onSelectImage = _this$props.onSelectImage,
        onClose = _this$props.onClose;
      onSelectImage(selectedImage);
      onClose();
    });
    return _this;
  }
  _createClass(AddImagePanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;
      if (open && !prevProps.open) {
        var _this$props2 = this.props,
          dismissError = _this$props2.dismissError,
          tags = _this$props2.tags,
          loadTags = _this$props2.loadTags;
        dismissError && dismissError();
        (!tags || !tags.length) && loadTags();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        tags = _this$props3.tags,
        images = _this$props3.images,
        onClose = _this$props3.onClose,
        classes = _this$props3.classes,
        loaderComponent = _this$props3.loaderComponent,
        width = _this$props3.width,
        open = _this$props3.open,
        onSelectTag = _this$props3.onSelectTag,
        client = _this$props3.client;
      var selectedImage = this.state.selectedImage;
      var showImageLibrary = images.length > 0;
      var showFilters = tags.length > 0;
      var applyButtonDisabled = (0, _isEmpty["default"])(selectedImage);
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: open,
        maxWidth: "md",
        fullWidth: true,
        onClose: onClose,
        fullScreen: width === 'sm' || width === 'xs',
        classes: {
          paper: classes.root
        }
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        disableTypography: true
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h5",
        className: classes.title
      }, (0, _i18n.t)('imageLibrary.gallery')), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        "aria-label": "close",
        className: classes.closeButton,
        onClick: onClose
      }, "close")), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, showImageLibrary && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loaderComponent, showFilters && /*#__PURE__*/_react["default"].createElement(_ImageLibraryFilter["default"], {
        tags: tags,
        applyFilter: onSelectTag
      }), /*#__PURE__*/_react["default"].createElement(_ImageLibraryThumbnail["default"], {
        motives: images,
        onSelect: this.onSelectImage,
        selected: selectedImage,
        client: client
      }))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
        classes: {
          root: classes.actionsRoot
        }
      }, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        disabled: applyButtonDisabled,
        fullWidth: (0, _withWidth.isWidthDown)('xs', width),
        onClick: function onClick() {
          return _this2.selectGalleryImage();
        },
        variant: "contained",
        className: classes.applyButton
      }, (0, _i18n.t)('fileUpload.apply'))));
    }
  }]);
  return AddImagePanel;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'AddImagePanel'
})(AddImagePanel));